import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileBend: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-bend, document"><path d="M12 2H5.75C4.7835 2 4 2.7835 4 3.75V20.25C4 21.2165 4.7835 22 5.75 22H18.25C19.2165 22 20 21.2165 20 20.25V10H13.75C12.7835 10 12 9.2165 12 8.25V2Z" fill="currentColor"/><path d="M19.5566 8.49993C19.5343 8.47493 19.5112 8.45051 19.4874 8.4267L13.5732 2.51249C13.5494 2.48868 13.525 2.46564 13.5 2.44336V8.24993C13.5 8.388 13.6119 8.49993 13.75 8.49993H19.5566Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFileBend;
